import React, {useEffect, useState} from "react";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import PropertyLines from "../src/components/propertyLines/PropertyLines";
import WaveLayout from "../src/layouts/WaweLayout";
import axios from "axios";


const Basin = () => {
    const [pressItem, setPressItem] = useState([]);

    useEffect(() => {
        const fetchPress = async () => {
            const {data} = await axios.get(`${process.env.NEXT_PUBLIC_AIRTABLE_TOKEN_PRESS_PAGES_URL}`, {
                headers: {
                    Authorization: `Bearer ${process.env.NEXT_PUBLIC_AIRTABLE_TOKEN_PRESS_PAGES}`,
                    'Content-Type': 'application/json'
                }
            });
            setPressItem(data.records);
        }
        fetchPress().then();

    }, []);
    return (
        <React.Fragment>
            <HtmlHead
                pageTitle={'Basin | Pembe Panjur'}
                description={'Evlilik Sitesi Pembe Panjur hakkında görsel ve yazılı basında çıkan haberler ve yorumlar. Pembe Panjur nasıl bir site, güvenilir mi?'}
            />

            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'} loginButtonText={false} hamburgerMenuType={'black'} registerButton={true}>
                <PropertyLines layoutPage={'basin'} propertyData={pressItem}/>
            </WaveLayout>
        </React.Fragment>
    )
}

import { checkAuthAndRedirect } from '../src/utils/authHelper';

export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};


export default Basin;
